module.exports = "/assets/listing/chefsMenuBannerMobile.png?TRdUtsg";